export const URL_LOGIN = '/login';
export const URL_FORGOT_PASSWORD = '/forgot-password';
export const URL_RESET_PASSWORD = '/reset-password';
export const URL_CHANGE_PASSWORD = '/change-password';
export const URL_DASHBOARD = '/dashboard';
export const URL_REPORTS = '/reports';
export const PAYOUT_REQUESTS = '/payout-requests';
export const REQUESTS_FOR_PAYOUT = '/requests-for-payout';
export const EMAIL_TEMPLATES = '/email-templates';
export const CONTACT_US_FORM_DATA = '/contact-us-data';
export const SATVIK_FOOD_ORDER = '/satvik-food-order';
export const DIVINE_SHOP_ORDER = '/divine-shop-order';

export const COMMUNITY_USERS = '/community-users';

export const PRASADAM_ORDER = '/prasadam-order';
export const URL_USER = '/user';
export const URL_PRIEST_USER = '/priest-user';
export const URL_VENDOR_USER = '/vendor-user';
export const URL_PRIEST_USER_REQUEST = '/priest-user-request';
export const URL_DRIVER_USER_REQUEST = '/driver-user-request';
export const URL_GUIDE_USER_REQUEST = '/guide-user-request';
export const URL_POST = '/post';
export const URL_SUB_ADMIN = '/sub-admin';
export const URL_BANNER = '/banner';
export const URL_TEMPLE = '/temple';
export const URL_TEMPLE_SLOT_BOOKINGS = '/temple-slot-bookings';
export const URL_TEMPLE_SLOT = '/temple/:id/slot';
export const URL_TEMPLE_SLOT_VIEW = '/temple/slot/:id';
export const URL_FOOD_CATEGORY = '/food-category';
export const URL_RESTAURANT = '/restaurant';
export const URL_FOOD_ITEM = '/food-item';
export const URL_FOOD_RESTAURANT_RANGE = '/food-restaurant-range/';
export const URL_PRODUCT_CATEGORY = '/product-category';
export const URL_PRODUCT_ITEM = '/product-item';
export const URL_STATIC_PAGE = '/static-page';
export const URL_PROFILE = '/profile';
export const URL_COMMISSION = '/commission';
export const URL_PROMO_CODE = '/promo-code';
export const URL_BLOCKED_USER = '/blocked-user';
export const URL_REPORTED_POST = '/reported-post';
export const URL_NORMAL_USER_POST = '/normal-user-post';
export const URL_REPORTED_COMMENTS = '/reported-comments';
export const URL_REPORTED_PROFILE = '/reported-profile';
export const URL_DHAM_MANAGEMENT = '/dham-management';
export const URL_DHAM_MANAGEMENT_REQUESTS = '/dham-management/requests';
export const URL_VISIT_MANAGEMENT = '/visit-management';
export const URL_ITINERY_MANAGEMENT = '/itinery-management';
export const URL_HOTELS_MANAGEMENT = '/hotels-management';
export const URL_TAXI_TRANSFER = '/taxi-transfer';
export const URL_BOOK_RIDE = '/book-ride';
export const URL_BOOK_GUIDE = '/book-guide';
export const URL_DRIVERS = '/drivers';
export const URL_GUIDE_MANAGEMENT = '/guide-management';
export const URL_KATHAKAR = '/kathakar';
export const URL_PUJARI = '/pujari';
export const URL_RIDE_MANAGEMENT = '/ride-management';
export const URL_ACTIVITIES_MANAGEMENT = '/activities-management';
export const URL_TEMPLE_MANAGEMENT = '/temple-management';
export const URL_POOJA_MANAGEMENT = '/pooja-management';
export const URL_SHOP_RANGE = '/shop-range';
export const URL_KATHA = '/katha';
export const URL_POOJA_CEREMONY = '/pooja-ceremony';
export const URL_POOJA_PACKAGE = '/pooja-package';
export const URL_BOOKINGS_KATHA_POOJA = '/bookings-katha-pooja';
